import Accordion from './accordion';
import Autocomplete from './autocomplete';
import backdrop from './backdrop';
import button from './button';
import buttonGroup from './button-group';
import card from './card';
import Checkbox from './checkbox';
import dialog from './dialog';
import drawer from './drawer';
import formControl from './form-control';
import formLabel from './form-label';
import iconButton from './icon-button';
import input from './input';
import list from './list';
import menu from './menu';
import pagination from './pagination';
import paper from './paper';
import popover from './popover';
import Radio from './radio';
import Select from './select';
import slider from './slider';
import snackbar from './snackbar';
import stepper from './stepper';
import switchOverrides from './switch';
import tablePagination from './table-pagination';
import tabs from './tabs';
import toggleButton from './toggle-button';
import tooltip from './tooltip';
import typography from './typography';

const overrides = () => {
  return Object.assign(
    {},
    Accordion(),
    stepper,
    Autocomplete(),
    backdrop,
    button,
    buttonGroup,
    card(),
    Checkbox,
    dialog(),
    drawer(),
    formLabel,
    formControl,
    iconButton,
    input,
    list,
    menu(),
    pagination,
    paper,
    popover(),
    Radio,
    Select,
    slider,
    snackbar(),
    switchOverrides,
    tablePagination,
    tabs,
    toggleButton,
    tooltip,
    typography
  );
};

export default overrides;
